import React, { useState }  from "react";
import { useViewport } from 'components/general/useViewPort'
import Label from "components/general/Label"
import SportCode from "components/common/SportCode"
import Competitor from "components/presentation/Competitor";
import Stack from 'react-bootstrap/Stack';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Button from 'react-bootstrap/Button';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faArrowUp, faAngleLeft, faAngleRight
} from "@fortawesome/free-solid-svg-icons";

function getInteger(value){
    return isNaN(value) ? 0 : parseInt(value) 
}

const Gates = ({config, row} ) => {
  const { breakPoint } = useViewport();
  const isMobile = (breakPoint === "sm" || breakPoint === "xs")    
  const intermediates = config?.extendedConfig?.filter(ec => ec?.code === 'INTERMEDIATE')?.sort((a, b) => (a?.pos === 'F' ? 999 : a?.pos) - (b?.pos === 'F' ? 999 : b?.pos));
  const gates = config?.extendedConfig?.filter(ec => ec?.code === 'GATE')?.sort((a, b) => a?.pos - b?.pos);
  const gates_num = config?.extendedConfig?.find(ec => ec?.code === 'GATES_NUM').value

  let _splits = []
  var index = 0
  var nextStart = 0
  intermediates.forEach((intermediate) =>{
    var start = index === 0 ? 1 : nextStart  
    var end = intermediate?.pos === 'F' ? getInteger(gates_num) : getInteger(intermediate?.value) 
    _splits.push(
        {
            "start": start
            ,"end": end
        }
    )
    index++
    nextStart = end + 1
  })

  const [currentIntermediate, setCurrentIntermediate] = useState(0);
  
  var from_gate = isMobile ? _splits[currentIntermediate].start : 1
  var to_gate = isMobile ? _splits[currentIntermediate].end : getInteger(gates_num)

  return (
      <>
      {isMobile && <ButtonGroupShowColumns currentIntermediate={currentIntermediate} setCurrentIntermediate={setCurrentIntermediate} splits={_splits}/>}            
      <table className="table table-detail">
          <thead>
              <tr>
                  <th><Label data="HeaderName"/></th>
                  {   
                    gates.map(gate => {
                        let direction = gate?.extension?.find(e => e.code === 'DIRECTION')?.value
                        let header = (direction === 'U')
                        ? <>{gate.value} <FontAwesomeIcon className='move-arrow-up' icon={faArrowUp} /></>
                        : gate.value
                        return(
                            <>
                            {
                                getInteger(gate.pos) >= from_gate 
                                && getInteger(gate.pos) <= to_gate 
                                && <th key={`detail-header-${gate.pos}`} className="text-center text-nowrap">{header}</th>
                            }
                            </>
                        )
                    })
                  }
              </tr>
          </thead>
          <tbody>
              <tr>
                  <th><Competitor {...row?.participant} hideNoc={true} hidePicture={true}/></th>
                  {   
                      gates.map(gate => {
                          let value = row?.extendedResults?.find(er => er.er_code === 'GATE_PTY' && er.er_pos === gate.pos)?.er_value
                          return(
                            <>
                            {
                                getInteger(gate.pos) >= from_gate 
                                && getInteger(gate.pos) <= to_gate 
                                && getGateCell(value, row.participant.code, gate.pos)
                            }
                            </>
                          )
                      })
                  }
              </tr>
        {
            row?.teamAthletes.map(teamAthlete => {
                //console.log(row?.teamAthletes)
                return(
                  <tr>
                    <th><Competitor {...teamAthlete?.athlete} hideNoc={true} hidePicture={true}/></th>
                    {   
                        gates.map(gate => {
                            let value = teamAthlete?.extResults 
                            ? teamAthlete?.extResults?.find(er => er.er_code === 'GATE_PTY' && er.er_pos === gate.pos)?.er_value
                            : teamAthlete?.extResultsCurrent?.find(er => er.er_code === 'GATE_PTY' && er.er_pos === gate.pos)?.er_value
                            return(
                                <>
                                {
                                    getInteger(gate.pos) >= from_gate 
                                    && getInteger(gate.pos) <= to_gate 
                                    && getGateCell(value, teamAthlete.athlete.code, gate.pos)
                                }
                                </>
                            )
                        })
                    }
                    </tr>                    
                )
            })  
        }
          </tbody>
      </table>
      </>
  )
}   
export default Gates;

function getGateCell(value, register, index){
    let colour = (value === undefined) 
        ? ''         
        : (value === '-')  
            ? 'bg-green'
            : 'bg-yellow'
    return(
      <td key={`detail-${register}-${index}`} className={`text-center ${colour}`}>
          {value}
      </td>
    )
}

const ButtonGroupShowColumns = ({ currentIntermediate, setCurrentIntermediate }) => {

    const handleClickArrow = (e) =>{
        if (e.currentTarget.value === 'left' && currentIntermediate > 0){
            setCurrentIntermediate(currentIntermediate-1)
        }
        if (e.currentTarget.value === 'right' && currentIntermediate < 2){
            setCurrentIntermediate(currentIntermediate+1)
        }
    }
  
    return (
      <>
        <Stack direction="horizontal">
          <div className="ms-auto"></div>
          <ButtonGroup size="sm">
            <Button variant="outline-dark" value="left"  onClick={handleClickArrow}>
              <FontAwesomeIcon className="font-icon" icon={faAngleLeft} />
            </Button>
            <Button variant="outline-dark" value="right" onClick={handleClickArrow}>
              <FontAwesomeIcon className="font-icon" icon={faAngleRight} />
            </Button>
          </ButtonGroup>    
        </Stack>
      </>
    );
  }